export default function PHP_stripos() {
  return (
    <div>
      <h1>PHP_stripos</h1>
    </div>
  );
}
